export function save(key: string, value: string | undefined): void {
  try {
    if (value === undefined) localStorage.removeItem(key)
    else localStorage.setItem(key, value)
  } catch {
    try {
      if (value === undefined) sessionStorage.removeItem(key)
      else sessionStorage.setItem(key, value)
    } catch {
    }
  }
}

export function load(key: string): string | undefined {
  try {
    return localStorage.getItem(key) ?? undefined
  } catch {
    try {
      return sessionStorage.getItem(key) ?? undefined
    } catch {
      return undefined
    }
  }
}
